import { Paragraph, Title } from '@restworld/ui-ds';
import { FlexCol } from './header';
import { ProposedJobPositionSetting } from './proposed-job-position-setting';
import 'twin.macro';
import { useTranslation } from 'next-i18next';
export const UserNotificationTab = () => {
  const { t } = useTranslation('user-settings');
  const subTitle = t('notification_tab_subheader');
  return (
    <div tw="flex lg:flex-row flex-col lg:justify-between lg:items-start items-start justify-start w-full gap-8">
      <FlexCol tw="gap-2 items-start justify-start lg:w-[457px] w-full">
        <Title fontWeight="semibold" textColor="black" standardVariant="h4">
          {t('notification_tab_header')}
        </Title>
        <Title textColor="gray-600" fontWeight="normal" standardVariant="h5" desktopOnly={true}>
          {subTitle}
        </Title>
        <div tw="lg:hidden block w-full">
          <Paragraph color="gray-600" font="normal">
            {subTitle}
          </Paragraph>
        </div>
      </FlexCol>
      <FlexCol tw="lg:gap-8 gap-6 items-start justify-start lg:w-[500px] w-full">
        <ProposedJobPositionSetting />
      </FlexCol>
    </div>
  );
};
